"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var TranslationKey = /** @class */ (function () {
    function TranslationKey() {
        var _this = this;
        this.getActualKey = function (placeHolderKey, parentKey) {
            var basePath = _this.getBasePath(parentKey);
            var isIndependentKey = placeHolderKey.indexOf('.') > -1;
            var basePathIsEmpty = !basePath || !basePath.length;
            return (isIndependentKey || basePathIsEmpty) ? placeHolderKey : (basePath + '.' + placeHolderKey);
        };
        this.getBasePath = function (text) {
            var split = text.split('.');
            split.splice(-1);
            return split.join('.');
        };
    }
    return TranslationKey;
}());
exports.TranslationKey = TranslationKey;
exports.translationKey = new TranslationKey();
